import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export default function SuperAdminTenants() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data } = await api.get("/admin/tenants");
    setItems(data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const updatePlan = async (id, plan) => {
    await api.put(`/admin/tenants/${id}`, { plan });
    load();
  };

  const toggleActive = async (id, active) => {
    await api.put(`/admin/tenants/${id}`, { is_active: active });
    load();
  };

  if (loading) return <div className="text-slate-500">Loading…</div>;
  return (
    <div className="space-y-5 fade-in">
      <p className="text-slate-600">All registered customer workspaces.</p>
      <Card className="border-slate-100 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600">
            <tr>
              <th className="text-left px-4 py-3 font-semibold">Tenant</th>
              <th className="text-left px-4 py-3 font-semibold">Industry</th>
              <th className="text-left px-4 py-3 font-semibold">Plan</th>
              <th className="text-left px-4 py-3 font-semibold">Users</th>
              <th className="text-left px-4 py-3 font-semibold">Surveys</th>
              <th className="text-left px-4 py-3 font-semibold">Responses</th>
              <th className="text-left px-4 py-3 font-semibold">Status</th>
              <th className="text-right px-4 py-3 font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((t) => (
              <tr key={t.id} className="border-t border-slate-100">
                <td className="px-4 py-3">
                  <p className="font-bold text-[#1F3A6B]">{t.name}</p>
                  <p className="text-xs text-slate-500 font-mono">{t.slug}</p>
                </td>
                <td className="px-4 py-3 text-slate-700">{t.industry || "—"}</td>
                <td className="px-4 py-3">
                  <select data-testid={`admin-plan-${t.id}`} value={t.plan} onChange={(e) => updatePlan(t.id, e.target.value)} className="border border-slate-200 rounded-md px-2 py-1 text-xs bg-white">
                    {["free","starter","growth","enterprise"].map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                </td>
                <td className="px-4 py-3 tabular-nums">{t.users_count}</td>
                <td className="px-4 py-3 tabular-nums">{t.surveys_count}</td>
                <td className="px-4 py-3 tabular-nums">{t.responses_count}</td>
                <td className="px-4 py-3">{t.is_active ? <Badge className="bg-emerald-100 text-emerald-700">Active</Badge> : <Badge className="bg-slate-100 text-slate-600">Disabled</Badge>}</td>
                <td className="px-4 py-3 text-right">
                  <Button data-testid={`admin-toggle-${t.id}`} size="sm" variant="outline" onClick={() => toggleActive(t.id, !t.is_active)}>
                    {t.is_active ? "Disable" : "Enable"}
                  </Button>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={8} className="text-center text-slate-500 py-12">No tenants yet.</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
